module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid39_960x856.0fcf754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid39_960x856.jpg
// module id = Wdxe
// module chunks = 0